"use client";

import React from "react";
import { Handshake, Landmark, ChartLine } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseAreas = [{
  title: "First Team",
  description: "The pinnacle of Birkalla football. Competing at the highest level with a focus on tactical excellence, professional standards, and securing silverware for the club's historic trophy cabinet.",
  icon: Handshake
}, {
  title: "Reserves",
  description: "The vital bridge to senior football. Developing high-potential talent through rigorous training and competitive match play, ensuring a seamless transition to the First Team squad.",
  icon: Landmark
}, {
  title: "Under 18s",
  description: "The future of WT Birkalla. Our elite youth pathway focuses on technical mastery and physical preparation, molding the next generation of club legends in a high-performance environment.",
  icon: ChartLine
}];
export default function AreasOfExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222090" id="elite-squads" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent opacity-50"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-6 md:px-8 max-w-7xl relative z-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-sm font-bold tracking-widest text-primary uppercase mb-4 font-mono">
            Senior Football
          </h2>
          <h3 className="text-4xl md:text-6xl font-extrabold font-default text-foreground leading-tight tracking-tighter uppercase">
            Elite Squads
          </h3>
          <p className="mt-6 text-lg text-muted-foreground font-default leading-relaxed">
            Our senior programs are built on a foundation of discipline, development, and a winning culture. Explore the teams that represent the black and gold on the pitch.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {expertiseAreas.map((area, i) => <Card key={i} data-index={i} className={`group p-10 bg-card border-t-2 border-x-0 border-b-0 border-t-primary rounded-none shadow-lg hover:shadow-3xl transition-all duration-500 ease-out flex flex-col h-full transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <CardHeader className="p-0 mb-8">
                <div className="w-16 h-16 rounded-none bg-accent flex items-center justify-center mb-8 border border-secondary transition-colors duration-300 group-hover:bg-primary group-hover:border-primary">
                  <area.icon className="w-8 h-8 text-primary transition-transform duration-500 group-hover:scale-110 group-hover:text-primary-foreground" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-2xl font-extrabold font-default text-foreground group-hover:text-primary transition-colors duration-300 uppercase tracking-tight">
                  {area.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0 flex-grow">
                <p className="text-muted-foreground font-default leading-relaxed text-base">
                  {area.description}
                </p>
              </CardContent>
              
              {}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full"></div>
            </Card>)}
        </div>
      </div>
    </section>;
}